import ConfigParameter, { gettext } from "../ConfigParameter";

export default class ThankYouText extends ConfigParameter {

    constructor() {
        super('thankYouText', 'text', gettext('Thank you text'), 'mainConfig', gettext('Your entry has been saved'));
    }

}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/ThankYouText.js